var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "dialog-base",
    {
      attrs: {
        visible: _vm.visible,
        title: "Chọn tài khoản thanh toán trực tuyến",
        size: "md",
        "use-panel": false,
        "confirm-loading": _vm.loading,
        "confirm-text": "Lưu",
        "cancel-text": "Đóng",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        confirm: _vm.handleSubmit,
        cancel: _vm.handleClose,
      },
    },
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.formLoading,
              expression: "formLoading",
            },
          ],
          ref: "dataForm",
          staticClass: "sk-dialog-content",
          attrs: {
            model: _vm.dataForm,
            rules: _vm.formRules,
            "label-position": "left",
            "label-width": "155px",
          },
        },
        [
          _c(
            "div",
            { staticClass: "sk-panel" },
            [
              _c("div", { staticClass: "sk-panel-head" }, [
                _c("div", { staticClass: "sk-panel-icon" }, [
                  _c("i", { staticClass: "el-icon-bank-card" }),
                ]),
                _c("div", [
                  _c("p", { staticClass: "sk-panel-title" }, [
                    _vm._v("Chọn tài khoản thanh toán"),
                  ]),
                  _c("p", { staticClass: "sk-panel-subtitle" }, [
                    _vm._v(
                      "\n            Áp dụng cho " +
                        _vm._s(_vm.selectedCount) +
                        " phiếu thu đã chọn\n          "
                    ),
                  ]),
                ]),
              ]),
              _c(
                "el-form-item",
                {
                  staticClass: "sk-u-mt-12",
                  attrs: { label: "Tài khoản", prop: "applicableBankID" },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "Chọn tài khoản ngân hàng" },
                      model: {
                        value: _vm.dataForm.applicableBankID,
                        callback: function ($$v) {
                          _vm.$set(_vm.dataForm, "applicableBankID", $$v)
                        },
                        expression: "dataForm.applicableBankID",
                      },
                    },
                    _vm._l(_vm.bankList, function (item) {
                      return _c(
                        "el-option",
                        {
                          key: item.id,
                          attrs: {
                            label:
                              item.nameAccount + " - " + item.numberAccount,
                            value: item.id,
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "flex items-center gap-2" },
                            [
                              _c("img", {
                                staticClass: "rbfo-bank-logo",
                                attrs: { src: item.logo, alt: "logo" },
                              }),
                              _c("span", [
                                _vm._v(
                                  _vm._s(item.nameAccount) +
                                    " - " +
                                    _vm._s(item.numberAccount)
                                ),
                              ]),
                            ]
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "sk-note sk-note--warning sk-u-mt-12" }, [
            _c("i", { staticClass: "el-icon-warning-outline" }),
            _c("span", [
              _vm._v(
                "Tài khoản được chọn sẽ áp dụng cho tất cả phiếu thu trong danh sách."
              ),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }